import { Record } from 'immutable';
import { schema } from 'normalizr';

export const CompletedUnitCommand = new Record({
  id: undefined,
  command: undefined,
  data: undefined,
  created_time: undefined,
  processed_time: undefined,
  acknowledged_time: undefined,
  processed: undefined,
  success: undefined,
  error_code: undefined,
  error_description: undefined,
  sequence_number: undefined,
  site: undefined,
  user: undefined,
  bulk_command: null,
  pending_pk: null,
  display_name: null,
});

export const completedUnitCommandSchema = new schema.Entity('completedUnitCommands');

// for reading in nested models, object with { field: schema }
// completedUnitCommandSchema.define({  });
